import { IStartupRegisterable, IStartupRegistry, IStartupState } from 'app/startup/registry/types';

/**
 * Use this class for inheritance.
 */
export abstract class StartupRegisterable implements IStartupRegisterable {
    _startupRegistry: IStartupRegistry;
    _service: unknown;

    /**
     * A StartupRegisterable can be used as a base class or composed into your class
     * @param startupRegistry An instance of StartupRegistry that's managing app lifecycle
     */
    constructor(startupRegistry: IStartupRegistry) {
        this._startupRegistry = startupRegistry;

        // immediately register with the StartupRegistry
        this._startupRegistry.register(this);
    }

    /**
     * Get the current registration/ready status of this registerable
     */
    getState(): IStartupState {
        return this._startupRegistry.getState(this);
    }

    /**
     * Set this registerable as being ready
     */
    setReady(): void {
        this._startupRegistry.setReady(this);
    }

    /**
     * Wait for this registerable to be ready
     */
    async waitForReady(): Promise<void> {
        return this._startupRegistry.waitForReady(this);
    }

    /**
     * To be implemented by the child class. Is used by the registry
     * to signal the start of life time!
     */
    abstract start(): void;
}
